export const STOCK_BREAK_POINT = 5;

// Minimum number of characters needed to start searching in the webshop search bar
export const MIN_SEARCH_LENGTH = 2;
export const SEARCH_BAR_LIMIT = 5;
